import React, { Component } from "react";
import PropTypes from "prop-types";
import Info from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import * as Theme from "../../../app/Theme";
import * as GBConst from "../../GB/GBConst";
import * as HLConst from "../NonVisual/HLConst";
import HLNavBtnDiv from "../Other/HLNavBtnDiv";
import HLIntervTreeDialog from "../Other/HLIntervTreeDialog";

const indent = 10;

class HLStep1Form extends Component {
    static propTypes = {
        intervAreaObjList: PropTypes.arrayOf(PropTypes.object),
        intervObjList: PropTypes.arrayOf(PropTypes.object),
        onPageChange: PropTypes.func,
    };

    static defaultProps = {
        intervAreaObjList: [],
        intervObjList: [],
        onPageChange: () => console.log("onPageChange"),
    };

    state = {
        showIntervTreeDialog: false,
    };

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (pageID) => {
        this.props.onPageChange(pageID);
    };

    onIntervAreaInfoClick = () => {
        this.setState({
            showIntervTreeDialog: true,
        });
    };

    onIntervAreaDialogClose = () => {
        this.setState({
            showIntervTreeDialog: false,
        });
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderTextDiv = () => {
        const getIntervAreaUL = () => {
            const intervAreaObjList = this.props.intervAreaObjList;

            let intervAreas1DStrArray = [];

            for (let i = 1; i <= intervAreaObjList.length; i++) {
                const intervAreaObj = intervAreaObjList[i - 1];

                intervAreas1DStrArray.push(
                    <li>{intervAreaObj[HLConst.intervAreaObj.name][GBConst.language.english]}</li>
                );
            }

            return <ul>{intervAreas1DStrArray}</ul>;
        };

        const getIntervAreaRows = () => {
            const intervAreaObjList = this.props.intervAreaObjList;

            let intervAreaRowArray = [];

            for (let i = 1; i <= intervAreaObjList.length; i++) {
                const intervAreaObj = intervAreaObjList[i - 1];

                intervAreaRowArray.push(
                    <tr>
                        <td style={{ ...Theme.simpleBorderStyle, textAlign: "left" }}>
                            {intervAreaObj[HLConst.intervAreaObj.name][GBConst.language.english]}
                        </td>
                        <td style={Theme.simpleBorderStyle}></td>
                        <td style={Theme.simpleBorderStyle}></td>
                        <td style={Theme.simpleBorderStyle}></td>
                        <td style={Theme.simpleBorderStyle}></td>
                    </tr>
                );
            }

            return intervAreaRowArray;
        };

        const infoBtn = (
            <IconButton
                onClick={this.onIntervAreaInfoClick}
                style={{
                    color: Theme.HL_SecondaryColor,
                    cursor: "pointer",
                    display: "inline-block",
                    marginLeft: indent,
                    padding: 0,
                }}
            >
                <Info
                    style={{
                        color: Theme.HL_SecondaryColor,
                    }}
                />
            </IconButton>
        );

        let textDiv = (
            <div
                style={{
                    ...Theme.textFontStyle,
                    // backgroundColor : Theme.HL_PrimaryColor,
                    // color           : "white",
                    marginLeft: Theme.leftIndent,
                }}
            >
                <p
                    style={{
                        ...Theme.pageHeadingFontStyle,
                    }}
                >
                    {HLConst.step1AreaText1}
                    &nbsp;
                    {/*<span style = {Theme.stepSubTextHeadingFontStyle}>*/}
                    {HLConst.step1AreaText2}
                    {/*</span>*/}
                </p>

                <Divider
                    style={{
                        ...Theme.dividerStyle,
                    }}
                />

                <p>
                    Determine the best match between current coverage and one of coverage scale-up scenarios, by
                    intervention area: {infoBtn}
                </p>

                {getIntervAreaUL()}

                <p>
                    For each intervention area, choose one of the coverage scale-up scenarios that best fits your
                    current (baseline) and target coverage for the majority of interventions included in that
                    intervention area: 40% to 60%, 60% to 80%, 80% to 90% or 90% to 95%. Download the below table and
                    mark your chosen coverage scale-up scenario for each intervention area with an “x”.
                </p>

                <p>
                    Note: it is possible to choose different scale-up scenarios for different intervention areas, or per
                    different humanitarian contexts (e.g., camps/settlements/urban areas). Not all intervention areas
                    need to be included if coverage data are missing.
                </p>

                <table
                    cellpadding={5}
                    style={{
                        ...Theme.simpleBorderStyle,
                        textAlign: "center",
                    }}
                >
                    <tr
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        <td
                            rowspan={2}
                            style={{
                                ...Theme.simpleBorderStyle,
                                padding: 5,
                                width: 150,
                            }}
                        ></td>
                        <td
                            colspan={4}
                            style={{
                                ...Theme.simpleBorderStyle,
                                padding: 5,
                                width: 150,
                            }}
                        >
                            Coverage scale-up scenario: from current (baseline) to target coverage
                        </td>
                    </tr>

                    <tr
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        <td style={{ ...Theme.simpleBorderStyle, padding: 5, width: 150 }}>40% to 60%</td>
                        <td style={{ ...Theme.simpleBorderStyle, padding: 5, width: 150 }}>60% to 80%</td>
                        <td style={{ ...Theme.simpleBorderStyle, padding: 5, width: 150 }}>80% to 90%</td>
                        <td style={{ ...Theme.simpleBorderStyle, padding: 5, width: 150 }}>90% to 95%</td>
                    </tr>

                    {getIntervAreaRows()}
                </table>

                <div
                    style={{
                        ...Theme.exampleDivStyle,
                    }}
                >
                    <p>
                        <span
                            style={{
                                textDecoration: "underline",
                            }}
                        >
                            For example:
                        </span>
                        &nbsp;if coverage of breastfeeding interventions is currently 65% and DTP3 coverage is 92%, you
                        may want to choose the 60% to 80% coverage scale-up scenario for Nutrition and the 90% to 95%
                        scale-up scenario for EPI.
                    </p>
                </div>
            </div>
        );

        return textDiv;
    };

    render() {
        const props = this.props;
        const intervAreaObjList = props.intervAreaObjList;
        const intervObjList = props.intervObjList;

        const state = this.state;
        const showIntervTreeDialog = state.showIntervTreeDialog;

        // let divHeight = "100%";

        // let creditText = null;

        // const downloadLab =
        //     <TLabel
        //         caption = {"Download guidance document and example"}
        //         style   = {{
        //             ...Theme.labelFontStyle,
        //         }}
        //     />;

        //const downloadGuideBtn =
        //    <HLDownloadGuideBtn/>;

        const navBtnDiv = (
            <HLNavBtnDiv
                onBackBtnClick={() => this.onPageChange(HLConst.stepByStepForm)}
                onNextBtnClick={() => this.onPageChange(HLConst.step2Form)}
            />
        );

        let intervTreeDialog = null;
        if (showIntervTreeDialog) {
            intervTreeDialog = (
                <HLIntervTreeDialog
                    onDialogClose={this.onIntervAreaDialogClose}
                    intervAreaObjList={intervAreaObjList}
                    intervObjList={intervObjList}
                />
            );
        }

        return (
            <div
                style={{
                    minHeight: window.innerHeight - Theme.HL_FooterOffset, //Theme.HL_FooterPosition,
                }}
            >
                {this.renderTextDiv()}
                {/*{downloadGuideBtn}*/}
                {navBtnDiv}
                {intervTreeDialog}
            </div>
        );
    }
}

export default HLStep1Form;
